import React, { useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  useTheme,
  Card,
  CardContent,
  CardMedia,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { tokens } from "../../theme";
import jsPDF from "jspdf";
import { getGeneralRoutine } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";

const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const days = [
    {
      label: "Día 1",
      value: "day1",
      description: "Trabajo profundo de glúteos y femorales para fuerza, forma y estabilidad.",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWC6aGm0ElmjehPNlb03nKf7xmrebF9yvydA&s",
    },
    {
      label: "Día 2",
      value: "day2",
      description: "Pecho y bíceps enfocados en volumen, definición y control muscular.",
      image:
        "https://image.tuasaude.com/media/article/dk/jp/exercicios-para-peitoral_32773.jpg?width=686&height=487",
    },
    {
      label: "Día 3",
      value: "day3",
      description: "Cuádriceps y hombros para desarrollar potencia, resistencia y estabilidad.",
      image:
        "https://st2.depositphotos.com/1594308/7977/i/450/depositphotos_79772706-stock-photo-woman-doing-exercise-for-legs.jpg",
    },
    {
      label: "Día 4",
      value: "day4",
      description: "Espalda y tríceps enfocados en fuerza, postura y definición.",
      image:
        "https://img.freepik.com/fotos-premium/espalda-chica-que-trabaja-gimnasio_665346-170920.jpg?semt=ais_hybrid&w=740&q=80",
    },
    {
      label: "Día 5",
      value: "day5",
      description: "Entrenamiento completo de piernas con enfoque explosivo y resistencia.",
      image:
        "https://i.blogs.es/5afdfb/anastase-maragos-aclkvemifl8-unsplash/1366_2000.jpeg",
    },
  ];


  useEffect(() => {
    dispatch(getGeneralRoutine());
  }, [dispatch]);

  const routine = useSelector((state) => state.General);

  const generateRoutinePDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const margin = 15;
    const pageHeight = doc.internal.pageSize.height;
    const maxWidth = doc.internal.pageSize.width - margin * 2;
    let y = margin;

    const data = routine?.[0]?.description;
    const dataName = routine?.[0]?.name || "Rutina";

    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.text(dataName, margin, y);
    y += 10;


    for (const { label, value, description } of days) {
      const exercises = data?.[value];
      if (!exercises || exercises.length === 0) continue;

      if (y > pageHeight - 40) {
        doc.addPage();
        y = margin;
      }

      doc.setFontSize(14);
      doc.setTextColor(30, 30, 150);
      doc.text(label, margin, y);
      y += 7;

      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.text(description, margin, y);
      y += 5;

      for (const [i, item] of exercises.entries()) {
        const drawExerciseCard = async (ex, sets, reps, instText = "") => {
          // Calcular altura dinámica basada en contenido
          let descriptionLines = 0;
          if (ex.description) {
            doc.setFontSize(8);
            const descLines = doc.splitTextToSize(`Descripción: ${ex.description}`, maxWidth - 10);
            descriptionLines = descLines.length;
          }
          
          let instTextLines = 0;
          if (instText) {
            doc.setFontSize(9);
            const instLines = doc.splitTextToSize(instText, maxWidth - 10);
            instTextLines = instLines.length;
          }
          
          const cardHeight = 35 + (descriptionLines * 4) + (instTextLines * 4) + ex.instructions.length * 5;
          
          if (y + cardHeight > pageHeight - 20) {
            doc.addPage();
            y = margin;
          }

          doc.setFillColor(245, 245, 245);
          doc.roundedRect(margin, y, maxWidth, cardHeight, 5, 5, "F");

          doc.setFont("helvetica", "bold");
          doc.setFontSize(11);
          doc.setTextColor(0, 0, 0);
          doc.text(`${ex.name}`, margin + 5, y + 8);

          doc.setFont("helvetica", "normal");
          doc.setFontSize(9);
          doc.text(`Series: ${sets} | Reps: ${reps}`, margin + 5, y + 15);
          
          let currentY = y + 21;
          
          if (instText) {
            const instLines = doc.splitTextToSize(instText, maxWidth - 10);
            instLines.forEach((line) => {
              doc.text(line, margin + 5, currentY);
              currentY += 4;
            });
          }

          if (ex.description) {
            doc.setFontSize(8);
            const descLines = doc.splitTextToSize(`Descripción: ${ex.description}`, maxWidth - 10);
            descLines.forEach((line) => {
              doc.text(line, margin + 5, currentY);
              currentY += 4;
            });
            currentY += 2; // Espacio adicional después de descripción
          }

          // Instrucciones
          doc.setFontSize(7);
          doc.text("Instrucciones:", margin + 5, currentY);
          currentY += 4;
          ex.instructions.forEach((step) => {
            const stepLines = doc.splitTextToSize(`- ${step}`, maxWidth - 13);
            stepLines.forEach((line) => {
              doc.text(line, margin + 8, currentY);
              currentY += 4;
            });
          });
          
          y += cardHeight + 5;
        };

        if (item.type === "single") {
          const { exercise, sets, reps, description } = item;
          await drawExerciseCard(exercise, sets, reps, description);
        }

        if (item.type === "superset") {
          if (y > pageHeight - 20) {
            doc.addPage();
            y = margin;
          }

          doc.setFont("helvetica", "bold");
          doc.setFontSize(10);
          doc.setTextColor(100, 0, 0);
          doc.text(`${i + 1}. Superset`, margin, y);
          y += 6;

          for (const sup of item.exercises) {
            const { exercise, sets, reps, description } = sup;
            await drawExerciseCard(exercise, sets, reps, description);
          }
        }
      }
    }

    doc.save("rutina.pdf");
  };


  return (
    <Box sx={{ padding: { md: "0 40px", xs: "0px 20px" }, mt: "30px" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: {md: "space-between", xs: "center"} ,
          alignItems: "center",
          textAlign: { xs: "center", md: "left" },
          mb: "15px",
        }}
      >
        <Box>
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            Rutina Fase 3
          </Typography>
          <Typography variant="h5" sx={{ marginBottom: 2 }}>
            De cosota sabrozonga a cosota sabrozonga definida
          </Typography>
        </Box>
        <Button variant="contained" sx={{ marginBottom: 2, width: { xs: "100%", md: "auto" } }} onClick={generateRoutinePDF}>
          Descargar PDF
        </Button>
      </Box>

      <Grid container spacing={3} justifyContent="flex-start">
        {days.map((day) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={day.value}>
            <Card
              sx={{
                backgroundColor: colors.grey[800],
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: 5,
                cursor: "pointer",
                transition: "transform 0.3s ease",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
              onClick={() => navigate(`/routines/${day.value}`)}
            >
              <CardMedia
                component="img"
                height="160"
                image={day.image}
                alt={`Imagen de rutina para ${day.label}`}
              />
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: "#fff" }}
                >
                  {day.label}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: colors.grey[300], mt: 1 }}
                >
                  {day.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Dashboard;
